export default "__VITE_ASSET__qLwFwidW__"